/* CashNCarry Loot - core (Loot pages only; loaded by layout/theme.liquid when body.cnc-loot).
   Ajax add to cart (/cart/add.js) wired into the theme's cart drawer, quick view with variant picker, Saved (hearts,
   localStorage in try/catch), toast, cart badge bump, first-add confetti, mobile tab bar.
   Vanilla JS, no libraries. UI words come from #cnc-loot-i18n (rendered by snippets/cnc-loot-ui.liquid). */
(function () {
  'use strict';
  if (!document.body.classList.contains('cnc-loot') || window.CncLoot) return;
  var T = {};
  try { T = JSON.parse(document.getElementById('cnc-loot-i18n').textContent); } catch (e) {}
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = ((window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || '/').replace(/\/$/, '');
  function t(k, map) { var s = T[k] || ''; if (map) Object.keys(map).forEach(function (m) { s = s.replace('[' + m + ']', map[m]); }); return s; }
  function money(c) {
    try { if (FoxTheme.Currency && FoxTheme.Currency.formatMoney) return FoxTheme.Currency.formatMoney(c, FoxTheme.settings.moneyFormat); } catch (e) {}
    return '$' + (c / 100).toFixed(2);
  }
  /* Storage: every read and write is wrapped (private mode, blocked storage, previews). */
  function sget(k, store) { try { var v = (store || localStorage).getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function sset(k, v, store) { try { (store || localStorage).setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* Toast */
  var toastEl = document.querySelector('[data-ltoast]'), toastTm;
  function toast(msg, link) {
    if (!toastEl) return;
    toastEl.textContent = '';
    var s = document.createElement('span'); s.textContent = msg; toastEl.appendChild(s);
    if (link) { var a = document.createElement('a'); a.href = link.href; a.textContent = link.text; if (link.onclick) a.addEventListener('click', link.onclick); toastEl.appendChild(a); }
    toastEl.classList.add('is-on');
    clearTimeout(toastTm); toastTm = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* Confetti: first add-to-cart of the session only, skipped with reduced motion. */
  function confetti(from) {
    if (RM || sget('cncLootConf', sessionStorage)) return;
    sset('cncLootConf', 1, sessionStorage);
    var r = from && from.getBoundingClientRect ? from.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight / 2, width: 0, height: 0 };
    var box = document.createElement('div'); box.className = 'lconf'; box.setAttribute('aria-hidden', 'true');
    var cols = ['#ff5a1f', '#ffd23f', '#29285d', '#c51625', '#2bb673', '#ff8a00'];
    for (var i = 0; i < 28; i++) {
      var p = document.createElement('i');
      var a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 110;
      p.style.left = (r.left + r.width / 2) + 'px'; p.style.top = (r.top + r.height / 2) + 'px';
      p.style.background = cols[i % cols.length];
      p.style.setProperty('--dx', Math.cos(a) * d + 'px'); p.style.setProperty('--dy', (Math.sin(a) * d - 40) + 'px');
      p.style.setProperty('--rot', (Math.random() * 720 - 360) + 'deg');
      box.appendChild(p);
    }
    document.body.appendChild(box);
    setTimeout(function () { box.remove(); }, 1300);
  }

  /* Cart count: tab bar number + bump animation on the theme's cart-count badges. */
  function bump(count) {
    document.querySelectorAll('[data-ltab-cartn]').forEach(function (n) { n.textContent = count; n.hidden = !count; });
    if (RM) return;
    document.querySelectorAll('cart-count, [data-ltab-cartn], .header__icon--cart, [data-ltab-cart] svg').forEach(function (el) {
      el.classList.remove('lbump'); void el.offsetWidth; el.classList.add('lbump');
    });
  }
  function afterAdd(btn, title) {
    toast(title ? t('addedOne', { title: title }) : t('added'), { href: root + '/cart', text: t('viewCart') });
    confetti(btn);
  }
  if (window.FoxTheme && FoxTheme.pubsub) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.cart && !e.cart.errors && typeof e.cart.item_count === 'number') bump(e.cart.item_count); });
  }
  /* Theme forms (product page, sticky bar): the theme opens the drawer; we add the toast and confetti. */
  document.addEventListener('product-ajax:added', function (e) {
    var p = e.detail && e.detail.product; afterAdd(document.activeElement, p && p.product_title);
  });

  /* Loot predictive search: the theme asks /search/suggest?loot=1; " AND tag:Loot" keeps the suggestions to Loot
     products (snippets/predictive-search strips it again for display). */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string' || input instanceof URL) {
        var u = new URL(String(input), location.href), q = u.searchParams.get('q');
        if (u.pathname.indexOf('/search/suggest') > -1 && u.searchParams.get('loot') === '1' && q && q.indexOf('tag:Loot') < 0) {
          u.searchParams.set('q', q + ' AND tag:Loot'); input = u.toString();
        }
      }
    } catch (e) {}
    return nativeFetch.apply(this, [input, init]);
  };

  function drawer() { return document.querySelector('cart-drawer'); }
  function add(id, qty, btn) {
    if (!id) return Promise.reject();
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var addRes;
    return fetch(root + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }], sections: sections.join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw res;
      addRes = res;
      return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      cart.sections = addRes.sections;
      if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      bump(cart.item_count);
      var it = addRes.items && addRes.items[0];
      afterAdd(btn, it && it.product_title);
      var d = drawer();
      if (d && FoxTheme.settings.cartType !== 'page') setTimeout(function () { try { d.show(btn); } catch (e) {} }, 250);
      return cart;
    }).catch(function (err) {
      toast((err && (err.description || err.message)) || t('error'));
      throw err;
    }).finally(function () {
      if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
    });
  }

  /* Quick view: products with options. Data from /products/<handle>.js; no stock counts are shown. */
  var qv = document.querySelector('[data-lqv]'), qvP = null, qvSel = [], qvOpener = null;
  function qvVariant() {
    if (!qvP) return null;
    return qvP.variants.find(function (v) { return v.options.every(function (o, i) { return o === qvSel[i]; }); }) || null;
  }
  function qvUpdate() {
    var v = qvVariant(), addB = qv.querySelector('[data-lqv-add]');
    qv.querySelector('[data-lqv-price]').textContent = v ? money(v.price) : '';
    var src = (v && v.featured_image && v.featured_image.src) || qvP.featured_image;
    if (src) { var img = qv.querySelector('[data-lqv-img]'); img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600'; img.alt = qvP.title; }
    addB.disabled = !(v && v.available);
    addB.textContent = !v ? t('unavailable') : v.available ? t('addToCart') : t('soldOut');
    qv.querySelectorAll('[data-lqv-o]').forEach(function (b) { b.setAttribute('aria-pressed', String(qvSel[+b.dataset.i] === b.dataset.v)); });
  }
  function qvOpen(handle, opener) {
    qvOpener = opener;
    if (opener) opener.classList.add('is-busy');
    fetch(root + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (p) {
      qvP = p;
      var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      qvSel = first.options.slice();
      qv.querySelector('[data-lqv-title]').textContent = p.title;
      qv.querySelector('[data-lqv-link]').href = root + '/products/' + p.handle;
      qv.querySelector('[data-lqv-err]').hidden = true;
      var tags = p.tags || [], sh = qv.querySelector('[data-lqv-ship]');
      if (sh) sh.textContent = tags.indexOf('Loot Ship:Free') > -1 ? t('shipFree') : tags.indexOf('Loot Ship:Paid') > -1 ? t('shipPaid') : t('shipMost');
      var box = qv.querySelector('[data-lqv-opts]'); box.textContent = '';
      (p.options || []).forEach(function (o, i) {
        var name = typeof o === 'string' ? o : o.name, vals = typeof o === 'string' ? [] : o.values;
        if (!vals.length) p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
        var g = document.createElement('fieldset'); g.className = 'lqv__opt';
        var lg = document.createElement('legend'); lg.textContent = name; g.appendChild(lg);
        vals.forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'lqv__val'; b.textContent = val;
          b.dataset.lqvO = ''; b.dataset.i = i; b.dataset.v = val;
          b.addEventListener('click', function () { qvSel[i] = val; qvUpdate(); });
          g.appendChild(b);
        });
        box.appendChild(g);
      });
      qvUpdate();
      qv.hidden = false; document.documentElement.classList.add('lqv-open');
      qv.querySelector('.lqv__box').focus({ preventScroll: true });
    }).catch(function () { location.href = root + '/products/' + handle; })
      .finally(function () { if (opener) opener.classList.remove('is-busy'); });
  }
  function qvClose() {
    if (!qv || qv.hidden) return;
    qv.hidden = true; document.documentElement.classList.remove('lqv-open');
    if (qvOpener && document.contains(qvOpener)) qvOpener.focus({ preventScroll: true });
  }
  if (qv) {
    qv.addEventListener('click', function (e) { if (e.target.closest('[data-lqv-close]')) qvClose(); });
    qv.querySelector('[data-lqv-add]').addEventListener('click', function () {
      var v = qvVariant(), b = this; if (!v) return;
      add(v.id, 1, b).then(qvClose, function (err) { var el = qv.querySelector('[data-lqv-err]'); el.textContent = (err && err.description) || t('error'); el.hidden = false; });
    });
    qv.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') qvClose();
      if (e.key === 'Tab') {
        var f = qv.querySelectorAll('button:not([disabled]), a[href]'); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
  }

  /* Saved (wishlist): handles in localStorage "cncLootSaved", newest first, max 60. */
  var KEY = 'cncLootSaved';
  function saved() { var s = sget(KEY); return Array.isArray(s) ? s : []; }
  function syncHearts() {
    var s = saved();
    document.querySelectorAll('[data-lc-save]').forEach(function (b) {
      var on = s.indexOf(b.dataset.lcSave) > -1, title = b.dataset.title || '';
      b.setAttribute('aria-pressed', String(on));
      if (title) b.setAttribute('aria-label', t(on ? 'unsave' : 'save', { title: title }));
    });
    document.querySelectorAll('[data-saved-count]').forEach(function (n) { n.textContent = s.length; n.hidden = !s.length; });
  }
  function toggleSave(h, btn) {
    var s = saved(), i = s.indexOf(h);
    if (i > -1) s.splice(i, 1); else s.unshift(h);
    sset(KEY, s.slice(0, 60));
    syncHearts();
    toast(i > -1 ? t('removed') : t('saved'), i > -1 ? null : { href: '/pages/loot?view=saved', text: t('saved') + ' ›' });
    if (btn && !RM) { btn.classList.remove('lpop'); void btn.offsetWidth; btn.classList.add('lpop'); }
    document.dispatchEvent(new CustomEvent('cnc-loot:saved', { detail: { handle: h, saved: i < 0 } }));
  }
  /* Theme product cards on Loot collection and search pages get a heart too. */
  function heartTheme(scope) {
    (scope || document).querySelectorAll('.product-card').forEach(function (card) {
      if (card.closest('.lc') || card.querySelector('[data-lc-save]')) return;
      var a = card.querySelector('a[href*="/products/"]'), wrap = card.querySelector('.product-card__image-wrapper');
      if (!a || !wrap) return;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (!m) return;
      var tt = card.querySelector('.product-card__title');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'lc__heart lc__heart--theme';
      b.dataset.lcSave = decodeURIComponent(m[1]); b.dataset.title = tt ? tt.textContent.trim() : '';
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.3 3 4.5 6.7 4.5c2.1 0 3.7 1.2 5.3 3 1.6-1.8 3.2-3 5.3-3 3.7 0 5.8 3.8 4.3 7.2C19.5 16.4 12 21 12 21z"/></svg>';
      wrap.appendChild(b);
    });
  }
  function prep(scope) {
    (scope || document).querySelectorAll('[data-lc-save]:not([data-title])').forEach(function (b) {
      var c = b.closest('[data-lc]'), tt = c && c.querySelector('.lc__title'); b.dataset.title = tt ? tt.textContent.trim() : '';
    });
    heartTheme(scope); syncHearts();
  }

  /* Clicks */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-lc-save],[data-lc-add],.lc__dot,[data-ltab-cart]');
    if (!el) return;
    if (el.hasAttribute('data-lc-save')) { e.preventDefault(); e.stopPropagation(); toggleSave(el.dataset.lcSave, el); return; }
    if (el.hasAttribute('data-lc-add')) { e.preventDefault(); if (el.hasAttribute('data-multi')) qvOpen(el.dataset.handle, el); else add(el.dataset.vid, 1, el).catch(function () {}); return; }
    if (el.classList.contains('lc__dot')) {
      var card = el.closest('[data-lc]'), img = card && card.querySelector('.lc__i1');
      if (img && el.dataset.img) { img.removeAttribute('srcset'); img.src = el.dataset.img; }
      card && card.querySelectorAll('.lc__dot').forEach(function (d) { d.classList.toggle('is-on', d === el); });
      return;
    }
    if (el.hasAttribute('data-ltab-cart')) { var d = drawer(); if (d && FoxTheme.settings.cartType !== 'page') { e.preventDefault(); d.show(el); } }
  });

  /* Back-to-top (theme component, enabled in theme settings): give its icon button a name. */
  document.querySelectorAll('back-to-top button').forEach(function (b) { if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', t('backToTop')); });

  prep();
  if ('MutationObserver' in window) {
    var mt;
    new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(function () { prep(); }, 120); })
      .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncHearts(); });

  window.CncLoot = { t: t, sget: sget, sset: sset, saved: saved, prep: prep, add: add, toast: toast, root: root, RM: RM };
})();